export default __webpack_public_path__ + "telephone-symbol-button.png";